import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
    EDITPROFILE: {
    path: `${baseRoutes.userBaseRoutes}editprofile`,
  },
};

export default accessRoute;
